// These ends up being used in a lot of places, so add constants
export const QUESTION_ODORS = 'qp/65';
export const QUESTION_TWO_KEYS = 'qp/79';
export const QUESTION_INCOMING_URL = 'qx/IncomingURL';
export const QUESTION_IP_ADDRESS = 'qx/IPAddress';
export const QUESTION_BROWSER_TYPE = 'qx/BrowserType';
export const QUESTION_LEAD_TYPE = 'qrv/LeadType';
export const QUESTION_OFFER_CODE = 'qx/OfferCode';
export const QUESTION_LNX_CODE = 'qx/LnxCode';
export const QUESTION_CUSTOM_ID = 'qx/CustomId';
export const QUESTION_PIXALL_ID = 'qx/PixAllID';
export const QUESTION_PIXALL_REAL_ID = 'qx/PixAllRealID';
export const QUESTION_SITE_REFERRAL_USER_ID = 'qx/SiteReferralUserID';
export const QUESTION_LOOKING_FOR = 'qrv/LookingFor';
export const QUESTION_NEW_CARS = 'qrv/LookingForNewCars';
export const QUESTION_CERTIFIED_CARS = 'qrv/LookingForCertifiedCars';
export const QUESTION_USED_CARS = 'qrv/LookingForUsedCars';
export const QUESTION_YEAR_RANGE = 'qrv/YearRange';
export const QUESTION_MAKE_MODEL = 'qrv/MakeModel1';
export const QUESTION_MAKE = 'qrv/Make';
export const QUESTION_MODEL = 'qrv/Model';
export const QUESTION_TOGGLE_MODIFICATIONS = 'toggleQuestionModifications1';
export const QUESTION_ARE_QUESTIONS_VERIFIED = 'qx/AreQuestionsVerified';
export const QUESTION_VERIFIED_MILEAGE = 'qx/VerifiedMileage';
export const QUESTION_AUCTION_QUESTION_ANSWERED_BY_USER = 'qx/AuctionQuestionAnsweredByUser';
export const QUESTION_ADDITIONAL_COMMENTS = 'qx/UserComments';
export const QUESTION_COBRANDING_GROUP_ID = 'qb/CobrandingGroupID';
export const QUESTION_CAPTCHA_RESULT = 'qint/CaptchaResult';
export const QUESTION_DISPOSAL_TYPE = 'qx/DisposalType';

// vehicle history
export const QUESTION_ORIGINAL_OWNER = 'qp/83';
export const QUESTION_VEHICLE_ISSUES = 'qp/124';
export const QUESTION_VEHICLE_AUCTION = 'qp/81';
export const QUESTION_VEHICLE_RENTAL = 'qp/125';

// condition quiz
export const QUESTION_VEHICLE_REAR_WINDOW_REPLACED_1 = 'qc/2020306/1';
export const QUESTION_VEHICLE_REAR_WINDOW_REPLACED_2 = 'qc/2020306/2';
export const QUESTION_VEHICLE_FRONT_WINDOW_REPLACED_1 = 'qc/2020303/1';
export const QUESTION_VEHICLE_FRONT_WINDOW_REPLACED_2 = 'qc/2020303/2';
export const QUESTION_CONDITION_TIER_SELECTION = 'qc/ConditionTierSelection';

// autocheck tracking
export const QUESTION_HAS_FLOOD_DAMAGE = 'hasFloodDamage';
export const QUESTION_HAS_FRAME_DAMAGE = 'hasFrameDamage';
export const QUESTION_IS_SALVAGE = 'isSalvage';
export const QUESTION_PREVIOUSLY_CANADIAN = 'previouslyCanadian';
export const QUESTION_NOT_ACTUAL_MILEAGE = 'notActualMileage';
export const QUESTION_IS_AUTOCHECK_AUCTION_ELIGIBLE = 'isAutocheckAuctionEligible';
export const QUESTION_AUTOCHECK_DATA_JSON = 'autoCheckDataJSON';

// Top level grouping of questions
export function getItemsByCanonicalName(coll, key: string = '') {
  return coll.find((i) => i.canonicalName === key).items;
}

export function getSubsectionGroup(coll, key: string = '') {
  return coll.filter((i) => i.subsection === key);
}

export function getSectionFromItems(coll, key: string = '') {
  return coll.filter((c) => c.section === key);
}

export function getItemSubset(coll, key: string = '') {
  return coll.filter((c) => c.item === key);
}

export function filterQuestionsCollection(coll = [], keepMatchers = []) {
  return coll.filter((q) => keepMatchers.indexOf(q.questionId) > -1);
}

export function getInteriorQuestionProps() {
  return { section: 'Vehicle Condition', subsection: 'Interior Wear or Damage' };
}

export function pluckQuestion(coll = [], questionId: string = '') {
  return coll.find((q) => q.questionId === questionId);
}

export function answersArrayToMap(answers, includeQuestionType = false) {
  if (includeQuestionType) {
    return answers.reduce((acc, a) => {
      acc[a.qRef || a.questionId] = { value: a.value || a.selected || '', comment: '', isRequired: a.isRequired, type: a.questionType };
      return acc;
    }, {});
  }
  return answers.reduce((acc, a) => {
    acc[a.qRef || a.questionId] = { value: a.value || a.selected || '', comment: '', isRequired: a.isRequired };
    return acc;
  }, {});
}

export function getQuestionsByType(coll = [], type = '') {
  return coll.filter((q) => q.questionType === type);
}

// ToggleSelect or Boolean: [true, false]
// Enum: enumChoices

export function renderQuestion(question) {
  switch (question.questionType) {
    case 'Boolean': // yes/no
      // label, questionId
      break;
    case 'Integer':
      // label, questionId
      break;
    case 'Enum':
      // label, questionId, enumChoices
      break;
    case 'SingleSelect':
      // acceptsComment, comment, manditory, maximumValue, minimumValue, selectChoices
      break;
    case 'MultiSelect':
      // acceptsComment, comment, manditory, maximumValue, minimumValue, selectChoices
      break;
    case 'ToggleSelect':
      // manditory: false, maximumValue, minimumValue,
      break;
    case 'Subquestion': // replacement vehicle only
      break;
    case 'IntegerRange': // replacement vehicle
      break;
    case 'String': // replacement vehicle
      break;
  }
}

export function checkIsSelected(value) {
  // checks if type is boolean | string - convert to boolean
  return typeof value === 'boolean' ? value : value === 'true';
}

export const extractAllByType = (questions, includeQuestionType = false) => {
  const multiSelect = getQuestionsByType(questions, 'MultiSelect');
  const singleSelect = getQuestionsByType(questions, 'SingleSelect');
  const integerQuestions = getQuestionsByType(questions, 'Integer');
  const toggleSelect = getQuestionsByType(questions, 'ToggleSelect');
  const enumQuestions = getQuestionsByType(questions, 'Enum');
  const rangeQuestions = getQuestionsByType(questions, 'IntegerRange');
  const subQuestions = getQuestionsByType(questions, 'Subquestion');
  const booleanQuestions = getQuestionsByType(questions, 'Boolean');
  // Structure all subquestions and set initial values
  const data = [...multiSelect, ...singleSelect, ...subQuestions]
    .map((q) => ({ type: q.questionType, choices: q.selectChoices || q.subquestions }))
    .flatMap((x) =>
      [...x.choices].map((y) => {
        y.type = x.type;
        return y;
      })
    );
  const selectChoices = Object.assign({}, ...data.map((x) => ({ [x.qRef || x.questionId]: { value: false, comment: '', ...(includeQuestionType && { type: x.type }) } })));
  return { ...answersArrayToMap([...integerQuestions, ...toggleSelect, ...enumQuestions, ...rangeQuestions, ...booleanQuestions], includeQuestionType), ...selectChoices };
};

// Question comes in as Boolean setup but to display it correctly with radio buttons, this is setup to be enum
export const twoKeysStaticQuestion = {
  questionId: QUESTION_TWO_KEYS,
  questionType: 'Boolean',
  isRadioInputStyle: true,
  label: 'Do You Have 2 or More Keys or Keyless Remotes?',
  enumChoices: ['Yes', 'No'],
  enumValues: [true, false],
  isRequired: true,
  dataTestId: 'twoKeysQuestion',
};

// Dummy question for toggling modifications section
export const toggleModificationsQuestion = {
  questionId: QUESTION_TOGGLE_MODIFICATIONS,
  questionType: 'Boolean',
  itemDescription: '(Example: custom wheels/tires, suspension kit, upgraded stereo, performance modifications and/or upgraded exhaust system)',
  isRadioInputStyle: true,
  label: 'Has Your Vehicle Had Any Modifications?',
  enumChoices: ['Yes', 'No'],
  enumValues: [true, false],
  isRequired: false,
  dataTestId: 'vehicleModificationsQuestion',
};

// Add custom questions - THIS IS NOT STANDARD, DOING IT FOR MVP. SHOULD BE COMING FROM API
export const addOtherQuestions = [
  { questionId: QUESTION_PIXALL_ID, questionType: 'String' },
  { questionId: QUESTION_PIXALL_REAL_ID, questionType: 'String' },
  { questionId: QUESTION_ARE_QUESTIONS_VERIFIED, questionType: 'String' },
  { questionId: QUESTION_VERIFIED_MILEAGE, questionType: 'String' },
  { questionId: QUESTION_AUCTION_QUESTION_ANSWERED_BY_USER, questionType: 'String' },
  { questionId: QUESTION_CUSTOM_ID, questionType: 'String' },
];

export const autocheckDataQuestions = [
  { questionId: QUESTION_HAS_FLOOD_DAMAGE, questionType: 'Boolean' },
  { questionId: QUESTION_HAS_FRAME_DAMAGE, questionType: 'Boolean' },
  { questionId: QUESTION_IS_SALVAGE, questionType: 'Boolean' },
  { questionId: QUESTION_PREVIOUSLY_CANADIAN, questionType: 'Boolean' },
  { questionId: QUESTION_NOT_ACTUAL_MILEAGE, questionType: 'Boolean' },
  { questionId: QUESTION_IS_AUTOCHECK_AUCTION_ELIGIBLE, questionType: 'Boolean' },
  { questionId: QUESTION_AUTOCHECK_DATA_JSON, questionType: 'String' },
];

export const getQuestionIds = (questions = []) => {
  return questions
    .map((question) => {
      if (question.selectChoices?.length > 0) {
        return question.selectChoices.map((choice) => choice.qRef);
      }
      return question.questionId;
    })
    .reduce((acc, curVal) => {
      return acc.concat(curVal);
    }, []);
};
